import React, { forwardRef } from "react";
import { useState } from "react";

import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";

import OtpInput from "react-otp-input";
import OtpTimer from "otp-timer";
import { useSelector, useDispatch } from "react-redux";
import Slide from "@mui/material/Slide";

import "./registerView.css";
import { DARK_BG, BLACK, ERROR } from "../../utilities/colors";

// IMAGE IMPORTING

import CloseIcon from "../../assets/icon/close-icon.png";
import { useEffect } from "react";
import {
  countryCodes,
  userDetails,
  userLogin,
  userProfileUpdate,
  userRegistrationOtp,
  userVerifyOtp,
} from "../../services/MainApiDetails";
import { User } from "../../actions";
import isLogged from "../../reducers/isLogged";
import userData from "../../reducers/userDetails";

var CryptoJS = require("crypto-js");

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: DARK_BG,
  border: `2px solid ${BLACK}`,
  boxShadow: 24,
  p: 4,
  background: `${DARK_BG} 0% 0 % no - repeat padding- box`,
  borderRadius: "16px",
  opacity: "1",
};

const RegisterView = ({ btnText }) => {
  const [otp, setOtp] = useState("");
  const [defaultDialCode, setDefaultDialCode] = useState("+91");
  const [otpRes, setOtpRes] = useState("");
  const [phone, setPhone] = useState("");
  const [userName, setUserName] = useState("");
  const [webBio, setWebBio] = useState("");
  const [webToken, setWebToken] = useState("");
  
  const [errors, setErrors] = useState({
    phone: "",
    name: "",
    otp: "",
  });

  const dispatch = useDispatch();

  const [loginStep, setLoginStep] = useState(1);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [countryCode, setCountryCode] = useState("");
  // const [countryCodeFor, setCountryCodeFor] = useState("");
  const [countryCodeObj, setCountryCodeObj] = useState("");

  useEffect(() => {
    // encryptData()
    getCountryCodes();
  }, []);

  function getCountryCodes() {
    countryCodes({})
      .then((res) => {
        if (res.data.status === 1) {
          setCountryCode(res.data.result);
        }
      })
      .catch((err, message) => {
        console.log(err + message);
      });
  }

  function validatePhone() {
    var validation = false;

    let regex = /^(\+?[0-9]{2})?([0-9]{10})$/;
    validation = regex.test(phone);

    return validation;
  }

  function registerUser(e) {
    e.preventDefault();
    var valid = true;
    var message = [];

    // let cCodeNum = countryCodeObj[0].dial_code;
    if (phone === "" || !validatePhone()) {
      message.phone = "Invalid phone number";
      setErrors(message);
    } else {
      let phoneNum = defaultDialCode + phone;

      console.log(phoneNum);

      let data;
      data = {
        phone: phoneNum,
      };
      userRegistrationOtp(data)
        .then((response) => {
          if (response.data.status === 1) {
            let otpResp = response.data.otp;

            setOtpRes(otpResp);
            setLoginStep(2);
          }
        })
        .catch((err, message) => {
          console.log(err + message);
        });
    }

    // setLoginStep(2);
  }

  function resendOtpUser() {
    let data;
    data = {
      phone: phone,
    };
    userRegistrationOtp(data)
      .then((response) => {
        if (response.data.status === 1) {
          let otpResp = response.data.otp;
          setOtpRes(otpResp);
          // setLoginStep(2);
        }
      })
      .catch((err, message) => {
        console.log(err + message);
      });
  }

  // console.log("OOOTTTPPP");
  // console.log(otpRes);
  // console.log("OOOTTTPPP");

  function registerUserOtp(e) {
    userVerifyOtp({
      phone: defaultDialCode + phone,
      otp: parseInt(otp),
    })
      .then((res) => {
        if (res.data.status === 1) {
          let countryCodeData = countryCode.find(
            (item) => item.dial_code == defaultDialCode
          );
          let cCodeStr = countryCodeData.code;
          let cCodeNum = countryCodeData.dial_code;
          alert(res.data.message);

          let data;
          data = {
            phone: phone,
            country_code: cCodeNum,
            iso_country_code: cCodeStr,
          };

          userLogin(data).then((response) => {
            if (response.data.status === 1) {
              dispatch({ type: "SIGN_IN" });
              setWebToken(response.data.web_token);
              userDetails().then((response) => {
                if (response.data.status === 1) {
                  // setUserName(response.data.user_data.name)
                  // if (response.data.user_data.web_bio != undefined)
                  // {
                  //   setWebBio(response.data.user_data.web_bio)
                  // }
                  //
                  // dispatch(User(response.data.user_data))
                  //
                  setLoginStep(3);
                }
              });
            }
            // window.location.href = "/";
          });
        } else {
          alert(res.data.message);
        }
      })
      .catch((err, message) => {
        console.log(err + message);
      });

    setLoginStep(3);
  }

  function registerUserName() {
    let message = [];
    // let cCodeNum = countryCodeObj[0].dial_code;
    if (userName.trim() === "") {
      message.name = "Please enter name";
      setErrors(message);
    } else {
      userProfileUpdate({
        name: userName,
        web_bio: webBio,
      })
        .then((res) => {
          if (res.data.status == 1) {
            alert("Profile updated successfully");
            userDetails().then((response) => {
              if (response.data.status === 1) {
                localStorage.setItem("webKey", webToken);
                dispatch(User(response.data.user_data));
              }
              // setOpen(false)
            });
          } else {
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }

  function handleOtpChange(otp) {
    setOtp(otp);
  }

  function countryCodeFunction(item) {
    let cCode = countryCode.filter((single) => single.dial_code === item);
    setDefaultDialCode(cCode[0].dial_code);

    setCountryCodeObj(cCode);
  }

  // console.log(countryCodeObj[0].dial_code + phone)

  function MenuItem() {
    switch (loginStep) {
      case 1:
        return (
          <div className="login-input-wrapper">
            <form action="">
              <div className="login-input-box">
                <span>Enter Your Phone Number</span>
                <div className="login-input-container">
                  <select
                    onChange={(e) => countryCodeFunction(e.target.value)}
                    name="country-code"
                    id="country-code"
                  >
                    {/* <option value={"63636b86e53484ea0aba1617"} selected>
                      +91
                    </option> */}
                    {countryCode
                      ? countryCode.map((item) => (
                          <option
                            key={item._id}
                            value={item.dial_code}
                            selected={
                              item.dial_code == defaultDialCode
                                ? "selected"
                                : ""
                            }
                          >
                            {item.dial_code}
                          </option>
                        ))
                      : ""}
                  </select>
                  {/* <select name="country-code" id="country-code">
                    <option value="in">+91</option>
                    <option value="uae">+973</option>
                    <option value="ksa">+966</option>
                    <option value="isa">+1</option>
                  </select> */}
                  <input
                    className="phone-input"
                    type="tel"
                    placeholder="+91 9043 123 743"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="login-btn-wrapper">
                <button onClick={registerUser}>Next</button>
              </div>
            </form>
          </div>
        );
      case 2:
        return (
          <div className="login-input-wrapper">
            <form action="">
              <div className="login-input-box">
                <span>Enter OTP</span>
                <OtpInput
                  value={otp}
                  onChange={handleOtpChange}
                  numInputs={6}
                  separator={<span>&nbsp;</span>}
                  containerStyle="otp-input-container"
                  inputStyle="otp-input"
                  focusStyle="otp-input-focus"
                />
              </div>
              <div className="login-btn-wrapper">
                <button type="button" onClick={registerUserOtp}>
                  Next
                </button>
              </div>
              <div className="resend-otp-wrapper">
                <OtpTimer
                  minutes={1}
                  seconds={1}
                  text="Resend OTP in"
                  ButtonText="Resend OTP"
                  resend={resendOtpUser}
                />
              </div>
            </form>
          </div>
        );
      case 3:
        return (
          <div className="login-input-wrapper">
            <form action="">
              <div className="login-input-box">
                <span>Enter Your Name</span>
                <input
                  className="name-input"
                  type="text"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  placeholder="Cristiano Ronaldo"
                />
                <span style={{ color: ERROR }}>{errors.name}</span>
              </div>
              <div className="login-input-box">
                <span>Enter Bio</span>
                <input
                  className="name-input"
                  type="text"
                  value={webBio}
                  onChange={(e) => setWebBio(e.target.value)}
                  placeholder=""
                />
              </div>
              <div className="login-btn-wrapper">
                <button type="button" onClick={registerUserName}>
                  Next
                </button>
              </div>
            </form>
          </div>
        );
      case 4:
        return (
          <div className="login-input-wrapper">
            {/* <ImageUpload /> */}
            {/* <ImageUpSamp /> */}
          </div>
        );
      default:
        return null;
    }
  }

  return (
    <div className="registerView">
      <div>
        <Button onClick={handleOpen}>{btnText}</Button>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <Box sx={style}>
              <div className="modal-close-icon">
                <img onClick={handleClose} src={CloseIcon} alt="" />
              </div>
              <div className="login-wrapper">
                <div className="login-header">
                  <h5>Log in to start predicting</h5>
                  <p>Save and track your predictions </p>
                  <p>Take on your friends</p>
                </div>
                {MenuItem()}
              </div>
            </Box>
          </Fade>
        </Modal>
      </div>
    </div>
  );
};

export default RegisterView;
